import { Injectable, TemplateRef } from '@angular/core';

export type Notification = {
  cssClass?: string;
  header?: string;
  delay?: number; // milliseconds
  body?: string;
  template?: TemplateRef<any>;
}

@Injectable({
  providedIn: 'root'
})
export class UiControllerService {

  public notifications:Notification[] = [
  ];

  constructor() { }

  addNote(note:Notification) {
    this.notifications.push(note);
  }

  removeNote(note:Notification) {
    this.notifications = this.notifications.filter((t) => t !== note);
  }

  clearAllNotifications(){
    this.notifications.splice(0, this.notifications.length);
  }


  notify(msgOrTmple:string|TemplateRef<any>, options:Notification={}){
    let note = Object.assign({},options);
    if (msgOrTmple instanceof TemplateRef){
        note.template = msgOrTmple;
    } else {
        note.body = msgOrTmple;
    }
    this.addNote(note);
  }

  notifySuccess(msgOrTmple:string|TemplateRef<any>, options:Notification={}){
    this.notify(msgOrTmple,{cssClass:'bg-success text-light'})
  }

  notifyError(msgOrTmple:string|TemplateRef<any>, options:Notification={}){
    this.notify(msgOrTmple,{cssClass:'bg-danger text-light'})
  }
}
